import { PaymentMethod } from '@40seas/entities/payment-methods';
import { BusinessLogicError } from '@40seas/errors';
import { PaymentMethodType } from '@40seas/models';
import Stripe from 'stripe';
import { ACHPaymentMethod } from '../ach-payment-method.entity';

export async function achPaymentMethodTypeHandler(stripePaymentMethod: Stripe.PaymentMethod): Promise<Partial<PaymentMethod>> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    if (stripePaymentMethod.us_bank_account?.networks.preferred !== PaymentMethodType.ACH) {
        throw new BusinessLogicError('This payment method type is not supported');
    }
    return {
        methodType: PaymentMethodType.ACH,
        methodTypeFields: {
            fingerPrint: stripePaymentMethod.us_bank_account.fingerprint,
            last4: stripePaymentMethod.us_bank_account.last4,
            bankName: stripePaymentMethod.us_bank_account.bank_name,
            routingNumber: stripePaymentMethod.us_bank_account.routing_number,
        } as ACHPaymentMethod,
    };
}
